import Link from "next/link";
import { Button } from "../ui/button";

export default function NotFound({ redirect_link }: { redirect_link: string }) {
  return (
    <main className="w-full h-full flex flex-col justify-center items-center gap-6">
      <h1 className="text-7xl font-bold tracking-wider">Oops!</h1>
      <h2 className="font-semibold text-2xl">404 - Page Not Found</h2>
      <p className="mx-4 text-center text-muted-foreground">
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable
      </p>
      <Button asChild>
        <Link prefetch={false} href={redirect_link}>
          Go to Home
        </Link>
      </Button>
    </main>
  );
}
